<div
  *rxIf="
    reactiveFormGroupComponent$ | push: mainDivRxRenderStrategy | detectChanges: mainDivRxRenderStrategy;
    strategy: mainDivRxRenderStrategy
  "
  [formGroup]="reactiveFormGroup$ | async">
  <input hidden #input [formControlName]="inputName" [id]="id" [name]="inputName" />

  <app-smart-filters-section
    [smartDataType]="Types.SmartDataType.Labels"
    [smartFilterIds]="smartFilterIds$ | async"
    (smartFilterRemoved)="smartFilterRemoved($event)"
    (smartFiltersAdded)="smartFiltersAdded($event)">
  </app-smart-filters-section>
</div>
